var React = require('react');

function TickIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.709 20.9102C5.26953 20.9102 0.748047 16.3887 0.748047 10.9492C0.748047 5.5 5.25977 0.988281 10.6992 0.988281C16.1484 0.988281 20.6699 5.5 20.6699 10.9492C20.6699 16.3887 16.1582 20.9102 10.709 20.9102ZM9.61523 15.7246C9.94727 15.7246 10.2305 15.5684 10.4355 15.2461L15.0254 8.01953C15.1426 7.81445 15.2695 7.58984 15.2695 7.375C15.2695 6.91602 14.8691 6.62305 14.4395 6.62305C14.1855 6.62305 13.9316 6.7793 13.7461 7.07227L9.57617 13.7715L7.59375 11.2129C7.34961 10.8906 7.13477 10.8027 6.85156 10.8027C6.41211 10.8027 6.07031 11.1641 6.07031 11.6035C6.07031 11.8281 6.1582 12.043 6.30469 12.2383L8.75586 15.2461C9.00977 15.5879 9.2832 15.7246 9.61523 15.7246Z","fill":"white"}));
}

TickIcon.defaultProps = {"width":"21","height":"21","viewBox":"0 0 21 21","fill":"none"};

module.exports = TickIcon;

TickIcon.default = TickIcon;
